import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Mobile-only floating "Apply" CTA. The `.float-apply` class already exists
 * in design-source/styles.css with the right positioning + hide-on-desktop.
 * Hidden on the admission page itself (where it would be redundant).
 */
export function FloatingApply() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show only after the user scrolls past the hero (~600px).
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (pathname.startsWith('/admission')) return null;
  if (!visible) return null;

  return (
    <Link to="/admission" className="float-apply" aria-label="Apply for admission">
      Apply
    </Link>
  );
}
